/* Keep one shared language preference across all pages. */
(() => {
  const picker=document.querySelector('#site-language');if(!picker)return;
  const codes=['de','en','ku','tr','ar'];
  let language='de',dictionary={},ready=false;
  try{const saved=localStorage.getItem('kurdistana-language');if(codes.includes(saved))language=saved;}catch(_){/* Browsing without storage remains usable. */}
  const textSources=new WeakMap(),attributeSources=new WeakMap();
  const attributes=['aria-label','alt','title','aria-valuetext','placeholder'];
  const normalize=text=>text.trim().replace(/\s+/g,' ');
  function translate(source,node){
    const key=normalize(source);
    const singleReview=key==='Bewertungen'&&/^1\s/.test(node?.parentElement?.closest('.reviews-num')?.textContent.trim()||'');
    if(singleReview)return {de:'Bewertung',en:'review',ku:'nirxandin',tr:'değerlendirme',ar:'تقييم'}[language];
    if(language==='de')return key==='1 Bewertungen'?source.replace('Bewertungen','Bewertung'):source;
    const value=dictionary[key]?.[codes.indexOf(language)-1];
    if(value)return source.match(/^\s*/)[0]+value+source.match(/\s*$/)[0];
    const reviews=key.match(/^(\d[\d.,]*)\s+Bewertungen?$/);
    if(reviews){
      const singular=Number(reviews[1])===1;
      const words={en:singular?'review':'reviews',ku:'nirxandin',tr:'değerlendirme',ar:singular?'تقييم':'تقييمات'};
      return `${reviews[1]} ${words[language]}`;
    }
    const relative=key.match(/^vor (\d+) (Sekunden?|Minuten?|Stunden?|Tag(?:en)?|Wochen?|Monat(?:en)?|Jahr(?:en)?)$/);
    if(relative){
      const unit=Object.entries({Sekund:'second',Minut:'minute',Stund:'hour',Tag:'day',Woch:'week',Monat:'month',Jahr:'year'}).find(([prefix])=>relative[2].startsWith(prefix))?.[1];
      if(unit){
        if(language==='ku')return `${relative[1]} ${{second:'çirke',minute:'deqîqe',hour:'saet',day:'roj',week:'hefte',month:'meh',year:'sal'}[unit]} berê`;
        return new Intl.RelativeTimeFormat(language,{numeric:'always'}).format(-Number(relative[1]),unit);
      }
    }
    const position=key.match(/^(\d+:\d+) von (\d+:\d+)$/);
    if(position)return `${position[1]} ${['of','ji','/','من'][codes.indexOf(language)-1]} ${position[2]}`;
    return source;
  }
  function textNode(node){
    if(!node.parentElement||node.parentElement.closest('script,style,noscript,svg,#site-language,code,[translate="no"]'))return;
    const value=node.nodeValue,prior=textSources.get(node);
    const source=prior&&value===prior.last?prior.source:value;
    const next=translate(source,node);textSources.set(node,{source,last:next});
    if(value!==next)node.nodeValue=next;
  }
  function element(node){
    if(node.closest('svg,option,[translate="no"]'))return;
    let saved=attributeSources.get(node);if(!saved){saved={};attributeSources.set(node,saved);}
    attributes.forEach(name=>{
      if(!node.hasAttribute(name))return;
      const current=node.getAttribute(name),prior=saved[name];
      const source=prior&&current===prior.last?prior.source:current;
      const next=translate(source);saved[name]={source,last:next};
      if(current!==next)node.setAttribute(name,next);
    });
  }
  function walk(node){
    if(node.nodeType===Node.TEXT_NODE){textNode(node);return;}
    if(node.nodeType!==Node.ELEMENT_NODE&&node.nodeType!==Node.DOCUMENT_NODE)return;
    if(node.nodeType===Node.ELEMENT_NODE){if(node.matches('script,style,noscript,svg,#site-language,[translate="no"]'))return;element(node);}
    const walker=document.createTreeWalker(node,NodeFilter.SHOW_ELEMENT|NodeFilter.SHOW_TEXT);
    let current;while((current=walker.nextNode())){if(current.nodeType===Node.TEXT_NODE)textNode(current);else element(current);}
  }
  const observer=new MutationObserver(records=>{
    if(!ready)return;
    observer.disconnect();
    for(const record of records){
      if(record.type==='characterData')textNode(record.target);
      else if(record.type==='attributes')element(record.target);
      else record.addedNodes.forEach(walk);
    }
    observe();
  });
  function observe(){observer.observe(document.documentElement,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:attributes});}
  function apply(){
    if(!ready)return;
    observer.disconnect();
    document.documentElement.lang=language;document.documentElement.dir=language==='ar'?'rtl':'ltr';
    picker.value=language;walk(document.documentElement);
    const early=document.querySelector('[data-early-email]');
    if(early){
      const messages={
        de:['Early Access – Amedspor-Armband','Hallo Baris,\nich möchte mir unverbindlich ein Amedspor-Armband für eine spätere Bestellung vormerken lassen. Bitte informiere mich, sobald es verfügbar ist.\nMeine Wunschfarbe: '],
        en:['Early access – Amedspor bracelet','Hi Baris,\nPlease put me down for an Amedspor bracelet, without any obligation to buy, and let me know when it becomes available.\nMy preferred colour: '],
        ku:['Gihîştina pêşwext – Destbenda Amedsporê','Silav Baris,\nEz dixwazim bê mecbûriyeta kirînê ji bo destbendeke Amedsporê navê xwe bidim nivîsandin. Dema amade bibe, ji kerema xwe min haydar bike.\nRengê ku ez dixwazim: '],
        tr:['Erken erişim – Amedspor bilekliği','Merhaba Baris,\nSatın alma zorunluluğu olmadan bir Amedspor bilekliği için ön kayıt yaptırmak istiyorum. Satışa çıktığında lütfen bana haber ver.\nTercih ettiğim renk: '],
        ar:['الوصول المبكر – سوار Amedspor','مرحبًا باريس،\nأرغب في تسجيل اهتمامي بسوار Amedspor لطلب لاحق دون أي التزام بالشراء. يرجى إخباري عند توفره.\nلوني المفضّل: ']
      };
      early.href=`mailto:info@kurdistanamin.de?subject=${encodeURIComponent(messages[language][0])}&body=${encodeURIComponent(messages[language][1])}`;
    }
    observe();
    document.dispatchEvent(new CustomEvent('sitelanguagechange',{detail:{language}}));
    window.dispatchEvent(new Event('resize'));
  }
  picker.addEventListener('change',()=>{
    language=picker.value;
    try{localStorage.setItem('kurdistana-language',language);}catch(_){}
    apply();
  });
  fetch(window.KM.asset('/translations.json?v=58')).then(response=>{if(!response.ok)throw new Error('translations');return response.json();}).then(data=>{dictionary=data;ready=true;apply();}).catch(()=>{
    picker.value='de';picker.disabled=true;
    picker.title='Sprachauswahl konnte nicht geladen werden. Bitte lade die Seite erneut.';
  });
})();
